import { isEmpty, isEqual, some } from 'lodash';
import { Box } from '@chakra-ui/react';
import { useNavigate, useParams } from 'react-router-dom';

import CustomerDetail from './CustomerDetail';
import CustomerLocation from './CustomerLocation';
import ParahubInformation from './ParahubInformation';
import { ConditionalComponent } from '@components/functionComponent';
import ParahubDetailSkeleton from '../skeleton/ParahubDetailSkeleton';
import { useGetStoreConfigDetail } from '../../hooks/query/useGetStoreConfig';
import { CardHeader } from './CardHeader';
import { CardDetail } from './CardDetail';
import useMutateStoreConfig from '@pages/Parahub/hooks/mutate/useMutateStoreConfig';
import { useEffect } from 'react';
import { initialChannelReport, useCustomerDetail } from '@pages/Parahub/hooks/state/useCustomerDetail';
import { useSnackbarNotification } from '@store/snackbarNotification';

export default function ParahubDetail() {
    const { id } = useParams();
    const navigate = useNavigate();
    const { onChangeSnackbarNotification } = useSnackbarNotification();
    const { formData, isDirty, setInitialData, resetState } = useCustomerDetail();

    const { data, isLoading } = useGetStoreConfigDetail(id);
    const { updateCP } = useMutateStoreConfig();

    const locationKeys = ['province', 'city', 'district', 'subdistrict', 'zip_code'];
    const isCustDetailWarning = isEqual(formData?.channel, initialChannelReport.name);
    const isCustLocationWarning = !isEmpty(formData) ? some(locationKeys, (key) => isEmpty(formData[key])) : false;

    const isShowButton = isDirty();

    const handleBackClick = () => {
        navigate(-1);
    };

    const parahubInfo = [
        { label: 'Parahub ID', value: formData?.parahub_id },
        { label: 'Parahub', value: formData?.parahub_name },
        { label: 'Distribution Center', value: formData?.nama_dc },
        { label: 'Sales Area', value: formData?.sales_area },
    ];

    const custDetail = [
        {
            label: 'Customer ID',
            value: formData?.customer_parahub_id,
            isRequired: true,
        },
        {
            label: 'Customer Name',
            value: formData?.customer_parahub_name,
            isRequired: true,
        },
        {
            label: 'Customer Channel Report',
            value: { id: formData?.channel_report_id, name: formData?.channel },
            isRequired: false,
        },
        { label: 'Sistem POS', value: formData?.pos_name, isRequired: true },
    ];

    const handleSubmit = () => {
        // if (isCustDetailWarning || isCustLocationWarning) {
        //     onChangeSnackbarNotification({
        //         status: 'error',
        //         title: 'Gagal menyimpan config!',
        //         description: `Tolong lengkapi semua form.`,
        //         duration: 3,
        //     });
        //     return;
        // }

        const payload = {
            customer_name: formData?.customer_parahub_name,
            channel: formData?.channel,
            channel_report_id: formData?.channel_report_id,
            latitude: formData?.latitude,
            longitude: formData?.longitude,
            province_id: formData?.province_id,
            city_id: formData?.city_id,
            district_id: formData?.district_id,
            village_id: formData?.subdistrict_id,
            zip: formData?.zip_code,
            address: formData?.address,
        };

        updateCP.mutate({ id, payload });
        setInitialData({ ...formData });
    };

    const handleCancel = () => {};

    useEffect(() => {
        if (data && !isLoading) {
            resetState();
            setInitialData(data);
        }
    }, [data]);

    return (
        <Box className="parahub-detail">
            <ConditionalComponent statement={!isLoading}>
                <CardHeader
                    onNavigateBack={handleBackClick}
                    onSubmit={handleSubmit}
                    onCancel={handleCancel}
                    mb={'24px'}
                    isLoading={false}
                    isShowButton={isShowButton}
                />

                <CardDetail title="Parahub Information" mb="24px">
                    <ParahubInformation parahubInfo={parahubInfo} />
                </CardDetail>

                <CardDetail
                    title="Customer Detail"
                    mb="24px"
                    isWarning={isCustDetailWarning}
                    warningLabel="Mohon sesuaikan data pada Customer Channel Report"
                >
                    <CustomerDetail custDetail={custDetail} />
                </CardDetail>

                <CardDetail
                    title="Customer Location"
                    mb="24px"
                    // isWarning={isCustLocationWarning}
                    warningLabel="Data-data di bawah ini perlu disesuaikan"
                >
                    <CustomerLocation />
                </CardDetail>
            </ConditionalComponent>

            <ConditionalComponent statement={isLoading}>
                <ParahubDetailSkeleton />
            </ConditionalComponent>
        </Box>
    );
}
